__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/f161695/_next/";